// extracted by mini-css-extract-plugin
export default {"container":"DocTree_container__YdRRe","empty":"DocTree_empty__uxc0O font-md-regular"};